import { useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BidQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const UPDATE_BID_WIN_THEME_MUTATION = graphql(`
  mutation updateBidWinTheme($UpdateBidWinThemeInput: UpdateBidWinThemeInput!) {
    updateBidWinTheme(UpdateBidWinThemeInput: $UpdateBidWinThemeInput) {
      id
      title
      description
      sources {
        title
        id
        type
        url
        chunkNumber
        documentType
        filePath
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
        isDeleted
        citationId
      }
    }
  }
`);

export function useUpdateBidWinTheme({ bidId }: { bidId: string }) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(UPDATE_BID_WIN_THEME_MUTATION, {
    onSuccess: (data) => {
      const updated = data.updateBidWinTheme;
      queryClient.setQueryData<BidQuery>(["bid", bidId], (prevData) => {
        if (!prevData?.bid) return prevData;
        return {
          ...prevData,
          bid: {
            ...prevData.bid,
            winThemes: prevData.bid.winThemes.map((theme) =>
              theme.id === updated.id ? updated : theme,
            ),
          },
        };
      });
    },
  });

  return { data: data?.updateBidWinTheme, ...rest };
}
